export enum Country {
  AUT,
  CHE,
  DEU,
  ITA
}
